import type { Role } from '../api/client';

const RANK: Record<Role, number> = { viewer: 0, operator: 1, admin: 2 };

/** Mirrors the API's `require_role` ranking (deps.py). */
export function atLeast(role: Role | undefined | null, minimum: Role): boolean {
  return role != null && RANK[role] >= RANK[minimum];
}
